import Collection from '../Collection';
import Detail from '../Detail';

export const routes = [
  {path: '/programmes', component: Collection, exact: true, public: false, right: 'admin-crud-programmes'},
  {path: '/programmes/:programmeUuid', component: Detail, exact: true, public: false, right: 'admin-crud-programmes'},
  {path: '/programmes/:programmeUuid/:onglet', component: Detail, exact: true, public: false, right: 'admin-crud-programmes'},
  {path: '/programmes/:programmeUuid/lots/lotUuid', component: Detail, exact: true, public: false, right: 'admin-crud-programmes'},
];
